import * as RadixVisuallyHidden from '@radix-ui/react-visually-hidden';
/** Contenu présent pour les lecteurs d'écran, retiré de l'affichage visuel. */
export const VisuallyHidden = RadixVisuallyHidden.Root;
//# sourceMappingURL=VisuallyHidden.js.map